export const documentTabs = {

    ECN: [
        { key: "header", label: "ECN Header" },
        { key: "product", label: "Product Information" },
        { key: "details", label: "ECN Details" },
        { key: "associated", label: "Associated Documents" },
        { key: "attachments", label: "Attachments" },
        { key: "properties", label: "Properties" }
    ],

    // Hotfix 20 / Audit gap #1 — added the "Revision Log" tab to every non-ECN
    // doctype, mirroring the legacy DMSNew form's Revision Log group box.
    // Empty for initial releases (backend writes "Initial Release" defaults
    // automatically); required on re-revisions of an already-released doc
    // (server-side validation refuses submit if rev>0 and prior DmsRevLog
    // rows exist for this DocID).

    SOP: [
        { key: "purpose", label: "Purpose" },
        { key: "scope", label: "Scope" },
        { key: "responsibilities", label: "Responsibilities" },
        { key: "definitions", label: "Definitions" },
        { key: "procedure", label: "Procedure" },
        { key: "revlog", label: "Revision Log" },
        { key: "associated", label: "Associated Documents" },
        { key: "attachments", label: "Attachments" },
        { key: "properties", label: "Properties" }
    ],

    WI: [
        { key: "purpose", label: "Purpose" },
        { key: "scope", label: "Scope" },
        { key: "responsibilities", label: "Responsibilities" },
        { key: "definitions", label: "Definitions" },
        { key: "workInstruction", label: "Work Instruction" },
        { key: "revlog", label: "Revision Log" },
        { key: "associated", label: "Associated Documents" },
        { key: "attachments", label: "Attachments" },
        { key: "properties", label: "Properties" }
    ],

    FCD: [
        { key: "purpose", label: "Purpose" },
        { key: "scope", label: "Scope" },
        { key: "responsibilities", label: "Responsibilities" },
        { key: "definitions", label: "Definitions" },
        { key: "form", label: "Form" },
        { key: "revlog", label: "Revision Log" },
        { key: "associated", label: "Associated Documents" },
        { key: "attachments", label: "Attachments" },
        { key: "properties", label: "Properties" }
    ],

    LIT: [
        { key: "purpose", label: "Purpose" },
        { key: "scope", label: "Scope" },
        { key: "responsibilities", label: "Responsibilities" },
        { key: "definitions", label: "Definitions" },
        { key: "notes", label: "Notes" },
        { key: "revlog", label: "Revision Log" },
        { key: "associated", label: "Associated Documents" },
        { key: "attachments", label: "Attachments" },
        { key: "properties", label: "Properties" }
    ]

};
export const literatureTypeOptions = [
    "Advertisement",
    "Brand Identity",
    "Catalog",
    "Display",
    "Instructions",
    "Newsletter",
    "Press Release",
    "Pricing",
    "Product Guide",
    "Sales Brochure",
    "Surgical Technique Guide",
    "Training",
    "Update Announcement"
];
